import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { useForm, useFormState } from 'react-final-form';

import ContactStepper from '../contact-stepper/ContactStepper';
import CommonButton, { BUTTON_STYLES } from '../../../components/common-button/CommonButton';
import Icon from '../../../icons/Icon';
import { ICONS } from '../../../icons';
import { CONTACT_STEPS } from '../../constants/contact';
import { validateStep } from './validation';
import StepRequestType from './steps/request-type/StepRequestType';
import StepContactInfo from './steps/contact-info/StepContactInfo';
import StepRequestDescription from './steps/request-description/StepRequestDescription';
import StepMessageSent from './steps/message-sent/StepMessageSent';

import scss from './ContactForm.module.scss';

function ContactFormInner({ onSubmit, onClose }) {
  const { t } = useTranslation('contact');

  const [activeStep, setActiveStep] = useState(0);

  const { values } = useFormState();
  const form = useForm();

  const handleCheckErrors = async () => {
    const stepErrors = await validateStep(activeStep, values);

    if (Object.keys(stepErrors).length > 0) {
      Object.keys(stepErrors).forEach((field) => {
        form.change(field, values[field] ?? '');
        form.blur(field);
      });
      return false;
    }

    return true;
  };

  const handleNext = async () => {
    const isValid = await handleCheckErrors();

    if (!isValid) {
      return;
    }

    setActiveStep((prevState) => prevState + 1);
  };

  const handlePrevious = () => {
    setActiveStep((prevState) => prevState - 1);
  };

  const handleSubmit = async () => {
    const isValid = await handleCheckErrors();

    if (!isValid) {
      return;
    }

    onSubmit();
    setActiveStep(CONTACT_STEPS.MESSAGE_SENT);
  };

  const mappedSubmitButtonData = {
    [CONTACT_STEPS.TYPE_OF_REQUEST]: {
      label: t('next'),
      icon: <Icon icon={ICONS.ArrowUp} className={scss.arrowIcon} />,
      onClick: handleNext,
    },
    [CONTACT_STEPS.CONTACT_INFORMATION]: {
      label: t('next'),
      icon: <Icon icon={ICONS.ArrowUp} className={scss.arrowIcon} />,
      onClick: handleNext,
    },
    [CONTACT_STEPS.REQUEST_DESCRIPTION]: {
      label: t('send'),
      icon: <MailOutlineIcon />,
      onClick: handleSubmit,
    },
  };

  return (
    <div className={scss.wrapper}>
      <ContactStepper activeStep={activeStep} />

      {activeStep === CONTACT_STEPS.TYPE_OF_REQUEST && <StepRequestType />}
      {activeStep === CONTACT_STEPS.CONTACT_INFORMATION && <StepContactInfo />}
      {activeStep === CONTACT_STEPS.REQUEST_DESCRIPTION && <StepRequestDescription />}
      {activeStep === CONTACT_STEPS.MESSAGE_SENT && <StepMessageSent onClose={onClose} />}

      {activeStep !== CONTACT_STEPS.MESSAGE_SENT ? (
        <div className={scss.actions}>
          <div>
            {activeStep > CONTACT_STEPS.TYPE_OF_REQUEST ? (
              <CommonButton styleColor={BUTTON_STYLES.SECONDARY} onClick={handlePrevious} maxWidth={144}>
                {t('previous')}
              </CommonButton>
            ) : null}
          </div>

          <CommonButton
            styleColor={BUTTON_STYLES.PRIMARY}
            onClick={mappedSubmitButtonData[activeStep].onClick}
            maxWidth={144}>
            {mappedSubmitButtonData[activeStep].label}
            {mappedSubmitButtonData[activeStep].icon}
          </CommonButton>
        </div>
      ) : null}
    </div>
  );
}

export default ContactFormInner;
